const Button = (props) => {
  const { type, className, onClick, disabled, children } = props;

  if (disabled) {
    return (
      <button type={type} disabled="disabled" className={className}>
        <span className="c7-loader" /> {children}
      </button>
    );
  }
  return (
    <button type={type} className={className} onClick={onClick}>
      {children}
    </button>
  );
};

export default Button;
